import * as React from 'react';
import { RadioGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { AlertType } from 'lib/alert/models';
import { useAlertForm } from '../Contexts/AlertFormContext';
import NextStepButton from './NextStepButton';
import { useAlertAction } from '../Contexts/AlertActionContext';

const AlertTypeStep = (): JSX.Element => {
    const { t } = useTranslation();

    const { alert, setAlert } = useAlertForm();
    const { action } = useAlertAction();

    const onConditionTypeChange = (
        event: React.ChangeEvent<HTMLInputElement>,
    ): void => {
        setAlert((prevState) => ({
            ...prevState,
            type: event.target.value,
        }));
    };

    return (
        <>
            <RadioGroup
                name="type"
                value={alert.type}
                onChange={onConditionTypeChange}
            >
                <FormControlLabel
                    value={AlertType.FIXED_THRESHOLD_CONDITION}
                    control={<Radio />}
                    label={t('alert.types.fixed_threshold_condition')}
                />
                <FormControlLabel
                    value={AlertType.DYNAMIC_THRESHOLD_CONDITION}
                    control={<Radio />}
                    disabled
                    label={t('alert.types.dynamic_threshold_condition')}
                />
                <FormControlLabel
                    value={AlertType.EVENT_CONDITION}
                    control={<Radio />}
                    disabled
                    label={t('alert.types.event')}
                />
            </RadioGroup>
            {action.name === 'create' && (
                <NextStepButton
                    disabled={!alert.type}
                    className="pendo-alerts-alerttype-step"
                />
            )}
        </>
    );
};

export default AlertTypeStep;
